import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Projects } from "@/components/site/Projects";
import { Comics } from "@/components/site/Comics";
import { Webtoons } from "@/components/site/Webtoons";
import { Timelapses } from "@/components/site/Timelapses";
import { Wip } from "@/components/site/Wip";
import { Latest } from "@/components/site/Latest";
import { About } from "@/components/site/About";
import { Skills } from "@/components/site/Skills";
import { Contact } from "@/components/site/Contact";
import { Support, hasSupport } from "@/components/site/support/Support";
import { Footer } from "@/components/site/Footer";
import { useProjects } from "@/hooks/useProjects";
import { useSite } from "@/hooks/useSite";
import { useList } from "@/hooks/useList";
import { scrollToId } from "@/lib/lenis";

export default function Home() {
  const { projects, loading } = useProjects();
  const [site] = useSite();
  const { items: series } = useList("/webtoons");
  const { items: videos } = useList("/videos");
  const { items: wip } = useList("/wip");
  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 450);
    return () => clearTimeout(t);
  }, [location.state, loading]);

  const works = projects.filter((p) => p.category !== "comic");
  const comics = projects.filter((p) => p.category === "comic");
  const sections = [
    ["works", (i) => <Projects key="works" index={i} projects={works} loading={loading} shape={site?.works_tile_shape} />],
    comics.length > 0 && ["comics", (i) => <Comics key="comics" index={i} comics={comics} />],
    series.length > 0 && ["webtoons", (i) => <Webtoons key="webtoons" index={i} series={series} />],
    videos.length > 0 && ["timelapse", (i) => <Timelapses key="timelapse" index={i} videos={videos} />],
    wip.length > 0 && ["wip", (i) => <Wip key="wip" index={i} items={wip} />],
    ["latest", (i) => <Latest key="latest" index={i} />],
    ["about", (i) => <About key="about" index={i} projects={projects} site={site} />],
    ["skills", (i) => <Skills key="skills" index={i} site={site} />],
    hasSupport(site) && ["support", (i) => <Support key="support" index={i} site={site} />],
    ["contact", (i) => <Contact key="contact" index={i} site={site} />],
  ].filter(Boolean);

  return (
    <main data-testid="home-page" className="bg-[#0B0C10] text-zinc-100">
      <Nav visible={sections.map(([id]) => id)} />
      <Hero site={site} />
      <Marquee />
      {sections.map(([, render], i) => render(String(i + 1).padStart(2, "0")))}
      <Footer />
    </main>
  );
}
